import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import giftCards from '@/assets/images/gift-cards.png';
import giftTravelImg from '@/assets/images/gift-travel-pack.png';
import useRoutes from '@/hooks/useRoutes';
import styles from './GiftTypeSelector.module.scss';
import { useAppSelector } from '@/hooks/useRedux';
import getSelectedPlan from '@/utils/getSelectedPlan';

interface IProps {
    itemBackground?: string;
    isFromGift?: boolean;
}

const GiftTypeSelector = ({ itemBackground = '#ffffff', isFromGift = false }: IProps) => {
    const planId = useAppSelector((state) => state.plan.currentPlan);
    const { isAloyPlan } = getSelectedPlan(planId);
    const { routes } = useRoutes();
    const { t } = useTranslation();

    return (
        <div className={`${styles.typesContainer} ${isFromGift && styles.typesContainerFromGift}`}>
            <Link
                to={routes.giftExperienceType}
                className={styles.itemContainer}
                style={{ background: itemBackground }}
            >
                <div className={styles.imageContainer}>
                    <img src={giftTravelImg} alt="" className={styles.giftTravelImg} />
                </div>
                <p className={styles.itemTitle}>{t('giftTravelTitle')}</p>
                <div className={styles.itemBody}>
                    <p className={styles.itemDescription}>{t('giftTravelDescription')}</p>
                    <span className={styles.button}>{isFromGift ? t('buy') : t('giftTravelButton')}</span>
                </div>
            </Link>

            <Link to={routes.giftCard} className={styles.itemContainer} style={{ background: itemBackground }}>
                <div className={styles.imageContainer}>
                    <img src={giftCards} className={styles.giftCardImg} alt="" loading="lazy" />
                </div>
                <p className={styles.itemTitle}>{t('giftCardTitle')}</p>
                <div className={styles.itemBody}>
                    <p className={styles.itemDescription}>{isAloyPlan ? t('aloyGiveCardDesc') : t('giveCardDesc')}</p>
                    <span className={styles.button}>{isFromGift ? t('buy') : t('giftCardButton')}</span>
                </div>
            </Link>
        </div>
    );
};

export default GiftTypeSelector;
